<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                时代的变迁
            </div>
            <div class="content">
                <table>
                    <tr>
                        <td width="60">历史时代</td>
                        <td width="50">百万年</td>
                        <td width="300">主要事件</td>
                    </tr>
                    <tr>
                        <td>冥古宙</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>隐生代</td>
                        <td>4570</td>
                        <td>地球出现</td>
                    </tr>
                    <tr>
                        <td>原生代</td>
                        <td>4150</td>
                        <td>地球上出现第一个生物---细菌</td>
                    </tr>
                    <tr>
                        <td>酒神代</td>
                        <td>3950</td>
                        <td>古细菌出现</td>
                    </tr>
                    <tr>
                        <td>早雨海代</td>
                        <td>3850</td>
                        <td>地球上出现海洋和其他的水</td>
                    </tr>
                    <tr>
                        <td>太古宙</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>始太古代</td>
                        <td>3800</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>古太古代</td>
                        <td>3600</td>
                        <td>蓝绿藻出现</td>
                    </tr>
                    <tr>
                        <td>中太古代</td>
                        <td>3200</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>新太古代</td>
                        <td>2800</td>
                        <td>第一次冰河期</td>
                    </tr>
                    <tr>
                        <td>元古宙</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>成铁纪</td>
                        <td>2500</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>层侵纪</td>
                        <td>2300</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>造山纪</td>
                        <td>2050</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>古元古代</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>固结纪</td>
                        <td>1800</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>盖层纪</td>
                        <td>1600</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>延展纪</td>
                        <td>1400</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>中元古代</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>狭带纪</td>
                        <td>1200</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>拉伸纪</td>
                        <td>1000</td>
                        <td>罗迪尼亚古陆形成</td>
                    </tr>
                    <tr>
                        <td>成冰纪</td>
                        <td>850</td>
                        <td>发生雪球事件</td>
                    </tr>
                    <tr>
                        <td>新元古代</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>埃迪卡拉纪</td>
                        <td>630 +5/-30</td>
                        <td>多细胞生物出现</td>
                    </tr>
                    <tr>
                        <td>显生宙</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>古生代</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>寒武纪</td>
                        <td>542.0 ± 1.0</td>
                        <td>寒武纪生命大爆发</td>
                    </tr>
                    <tr>
                        <td>奥陶纪</td>
                        <td>488.3 ± 1.7</td>
                        <td>鱼类出现；海生藻类繁盛</td>
                    </tr>
                    <tr>
                        <td>志留纪</td>
                        <td>443.7 ± 1.5</td>
                        <td>陆生的裸蕨植物出现</td>
                    </tr>
                    <tr>
                        <td>泥盆纪</td>
                        <td>416.0 ± 2.8</td>
                        <td>鱼类繁荣 两栖动物出现 昆虫出现 种子植物出现 石松和木贼出现</td>
                    </tr>
                    <tr>
                        <td>石炭纪</td>
                        <td>359.2 ± 2.5</td>
                        <td>昆虫繁荣 爬行动物出现 煤炭森林 裸子植物出现爬行动物出现</td>
                    </tr>
                    <tr>
                        <td>中生代</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>二叠纪</td>
                        <td>299.0 ± 0.8</td>
                        <td>二叠纪灭绝事件，地球上95%生物灭绝 盘古大陆形成</td>
                    </tr>
                    <tr>
                        <td>三叠纪</td>
                        <td>251.0 ± 0.4</td>
                        <td>恐龙出现 卵生哺乳动物出现</td>
                    </tr>
                    <tr>
                        <td>侏罗纪</td>
                        <td>199.6 ± 0.6</td>
                        <td>有袋类哺乳动物出现 鸟类出现 裸子植物繁荣 被子植物出现</td>
                    </tr>
                    <tr>
                        <td>白垩纪</td>
                        <td>99.6 ± 0.9</td>
                        <td>恐龙的繁荣和灭绝 白垩纪-第三纪灭绝事件，地球上45%生物灭绝 有胎盘的哺乳动物出现</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>新生代</td>
                        <td>65.5 ± 0.3</td>
                        <td>到现在</td>
                    </tr>
                </table>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "WalkCentury"
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .content {
                margin-top: 40px;
            }
            p {
                line-height: 12px;
            }

        }
    }
</style>